(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__sohaFreeShippingBarSection) return;
    window.__sohaFreeShippingBarSection = true;

    var PLACEHOLDER = /\[amount\]/g;
    var CART_MUTATION = /\/cart\/(add|change|update|clear)/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      var parts = (Math.abs(number) / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }

    function formatAmount(cents, allowDecimals) {
      cents = parseInt(cents, 10) || 0;
      var isWhole = cents % 100 === 0;
      var useDecimals = allowDecimals && !isWhole;
      var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
      var placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);
      var key = placeholder ? placeholder[1] : 'amount';
      var value;

      if (!useDecimals) {
        // Whole dollars: strip decimals from the shop money format.
        switch (key) {
          case 'amount_with_comma_separator':
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
          case 'amount_with_apostrophe_separator':
          case 'amount_no_decimals_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 0, "'", '.');
            break;
          case 'amount_with_space_separator':
          case 'amount_no_decimals_with_space_separator':
          case 'amount_with_period_and_space_separator':
            value = formatWithDelimiters(cents, 0, ' ', ',');
            break;
          default:
            value = formatWithDelimiters(cents, 0, ',', '.');
        }
      } else {
        switch (key) {
          case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 2, ',', '.');
            break;
          case 'amount_with_comma_separator':
          case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
          case 'amount_with_apostrophe_separator':
          case 'amount_no_decimals_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'", '.');
            break;
          case 'amount_with_space_separator':
          case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', ',');
            break;
          case 'amount_with_period_and_space_separator':
            value = formatWithDelimiters(cents, 2, ' ', '.');
            break;
          default:
            value = formatWithDelimiters(cents, 2, ',', '.');
        }
      }

      if (placeholder) {
        return format.replace(/\{\{\s*\w+\s*\}\}/, value);
      }
      return useDecimals ? (cents / 100).toFixed(2) + '$' : Math.round(cents / 100) + '$';
    }

    function fillAmount(template, cents, allowDecimals) {
      return (template || '').replace(
        PLACEHOLDER,
        '<span class="fs-body-bold">' + formatAmount(cents, allowDecimals) + '</span>'
      );
    }

    function updateBar(node, cartTotal) {
      if (!node) return;
      if (typeof cartTotal === 'number') {
        node.dataset.cartTotal = String(cartTotal);
      } else {
        cartTotal = parseInt(node.dataset.cartTotal, 10) || 0;
      }

      var threshold = Math.round(
        parseInt(node.dataset.threshold, 10) * ((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1)
      );
      if (!threshold || threshold < 1) return;

      var thresholdInCents = threshold * 100;
      var message = node.querySelector('.free-shipping-bar__message');
      var progressBar = node.querySelector('.free-shipping-bar__bar');
      var emptyMessage = node.dataset.freeShippingEmptyMessage || '';
      var successMessage = node.dataset.freeShippingSuccessMessage || '';
      var pendingMessage = node.dataset.freeShippingPendingMessage || '';

      node.classList.remove('free-shipping-bar--success', 'free-shipping-bar--empty');

      if (cartTotal <= 0) {
        node.classList.add('free-shipping-bar--empty');
        if (message) message.innerHTML = fillAmount(emptyMessage, thresholdInCents, false);
      } else if (cartTotal >= thresholdInCents) {
        node.classList.add('free-shipping-bar--success');
        if (message) message.textContent = successMessage;
      } else {
        var remainder = Math.abs(cartTotal - thresholdInCents);
        if (message) message.innerHTML = fillAmount(pendingMessage, remainder, true);
      }

      if (progressBar) {
        var progress = cartTotal <= 0 ? 0 : cartTotal < thresholdInCents ? cartTotal / threshold : 100;
        progressBar.style.setProperty('--progress-width', progress + '%');
      }

      node.classList.add('free-shipping-bar--loaded');
    }

    function updateAll(cartTotal) {
      document.querySelectorAll('[data-section-type="free-shipping-bar"] [data-free-shipping-bar]').forEach(function (node) {
        updateBar(node, cartTotal);
      });
    }

    function refreshFromCart() {
      var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart && window.theme.routes.cart.base) || '/cart';
      return fetch(cartUrl + '.js', { credentials: 'same-origin' })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          updateAll(cart.total_price);
          return cart;
        })
        .catch(function () {});
    }

    function initSection(container) {
      if (!container) return;
      var bar = container.querySelector('[data-free-shipping-bar]');
      if (bar) updateBar(bar);
    }

    function syncQuickSearchOffset() {
      if (document.body.getAttribute('quick-search-open') === 'true') return;
      var header = document.querySelector('.shopify-section.header__outer-wrapper');
      if (!header) return;
      var bottom = Math.round(header.getBoundingClientRect().bottom + window.scrollY);
      document.documentElement.style.setProperty('--quick-search-offset', bottom + 'px');
    }

    function watchQuickSearchOffset() {
      syncQuickSearchOffset();
      if (window.__sohaQuickSearchOffsetWatch) return;
      window.__sohaQuickSearchOffsetWatch = true;
      if (typeof ResizeObserver !== 'function') {
        window.addEventListener('resize', syncQuickSearchOffset);
        return;
      }
      var observer = new ResizeObserver(syncQuickSearchOffset);
      document.querySelectorAll('[data-section-type="free-shipping-bar"], .shopify-section.header__outer-wrapper').forEach(function (node) {
        observer.observe(node);
      });
      window.addEventListener('resize', syncQuickSearchOffset);
    }

    function initAll() {
      document.querySelectorAll('[data-section-type="free-shipping-bar"]').forEach(initSection);
      watchQuickSearchOffset();
    }

    document.addEventListener('DOMContentLoaded', initAll);
    if (document.readyState !== 'loading') initAll();

    document.addEventListener('shopify:section:load', function (event) {
      var target = event.target;
      if (!target) return;
      if (target.matches && target.matches('[data-section-type="free-shipping-bar"]')) {
        initSection(target);
        return;
      }
      var section = target.querySelector && target.querySelector('[data-section-type="free-shipping-bar"]');
      if (section) initSection(section);
    });

    document.addEventListener('apps:product-added-to-cart', function () {
      refreshFromCart();
    });

    document.addEventListener('cart:updated', function (event) {
      var cart = event && event.detail && event.detail.cart;
      if (cart && typeof cart.total_price === 'number') {
        updateAll(cart.total_price);
      } else {
        refreshFromCart();
      }
    });

    if (!window.__sohaFreeShippingBarFetchPatched) {
      window.__sohaFreeShippingBarFetchPatched = true;
      var originalFetch = window.fetch;
      if (typeof originalFetch === 'function') {
        window.fetch = function () {
          var args = arguments;
          var input = args[0];
          var url = typeof input === 'string' ? input : input && input.url;
          return originalFetch.apply(this, args).then(function (response) {
            if (url && CART_MUTATION.test(url)) {
              setTimeout(refreshFromCart, 50);
            }
            return response;
          });
        };
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product--default"]) return;
  try {
    
  (function () {
    if (window.__sohaZoorixFourCards) return;
    window.__sohaZoorixFourCards = true;

    function isOneColumn() {
      return !window.matchMedia('(min-width: 960px)').matches;
    }

    function cardsPerPage() {
      return isOneColumn() ? 2 : 4;
    }

    function placeWidget() {
      var section = document.querySelector('.product--main .section-inner');
      if (!section) return;
      var oneCol = isOneColumn();
      document.querySelectorAll('.product--main [data-location="main"]').forEach(function (el) {
        if (!el._sohaZrxHome) {
          el._sohaZrxHome = el.parentNode;
          el._sohaZrxNext = el.nextSibling;
        }
        if (oneCol) {
          if (el.parentNode !== section) section.appendChild(el);
        } else if (el._sohaZrxHome && el.parentNode !== el._sohaZrxHome) {
          el._sohaZrxHome.insertBefore(el, el._sohaZrxNext);
        }
      });
    }

    function applySlider(vm, count) {
      if (!vm) return;
      vm.itemsInView = count;
      vm._itemsInView = count;
      if (vm.$refs && vm.$refs.wrapper && vm.$refs.wrapper.offsetWidth) {
        vm.itemWidth = vm.$refs.wrapper.offsetWidth / count;
      }
      if (typeof vm.$forceUpdate === 'function') vm.$forceUpdate();
      if (typeof vm.scrollTo === 'function') vm.scrollTo(vm.currentSlide || 0);
    }

    function patch() {
      placeWidget();
      var count = cardsPerPage();
      document.querySelectorAll('.product--main .zrx-slider-template-container').forEach(function (el) {
        var vm = el.__vue__;
        if (!vm) return;
        applySlider(vm, count);
        var parent = vm.$parent;
        while (parent) {
          if (parent.slidesNumber) parent.slidesNumber = count;
          if (typeof parent.buildSlidesPerView === 'function') parent.slidesPerView = count;
          parent = parent.$parent;
        }
      });
    }

    document.addEventListener('zrx-loaded', function () {
      setTimeout(patch, 0);
      setTimeout(patch, 400);
    });
    window.addEventListener('load', function () {
      setTimeout(patch, 600);
    });
    window.addEventListener('resize', patch);
    if (window.matchMedia) {
      window.matchMedia('(min-width: 960px)').addEventListener('change', patch);
    }
  })();

  (function () {
    if (window.__sohaZoorixCartBridge) return;
    window.__sohaZoorixCartBridge = true;

    var syncTimer;

    function dismissZoorixUi() {
      document.querySelectorAll(
        '.zrx-info-popup-dismiss-button, .zrx-info-popup-close-button, .zrx-modal-mask .zrx-close-button'
      ).forEach(function (btn) {
        try {
          btn.click();
        } catch (err) {}
      });
    }

    function syncThemeCart(event) {
      var qty = event && event.detail && event.detail.quantity;
      if (qty === 0) return;

      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () {
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        dismissZoorixUi();
        setTimeout(function () {
          var icon = document.querySelector('[data-js-cart-icon]');
          if (icon) icon.click();
        }, 350);
      }, 50);
    }

    [
      'zrx-slider-item-added',
      'zrx-bundle-added',
      'zrx-pl-item-added',
      'zrx-main-product-added',
      'zrx-cart-item-added',
      'zrx-vd-added',
      'zrx-mix-and-match-added',
      'zrx-bogo-added'
    ].forEach(function (name) {
      document.addEventListener(name, syncThemeCart);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
